import { api } from "@/lib/api";

export const T_BADGE = { achieved: "bg-emerald-100 text-emerald-700", missed: "bg-red-100 text-red-700", in_progress: "bg-sky-100 text-sky-700", pending_review: "bg-amber-100 text-amber-800", upcoming: "bg-slate-100 text-slate-600" };
export const T_LABEL = { achieved: "Achieved", missed: "Missed", in_progress: "In progress", pending_review: "Pending review", upcoming: "Upcoming" };
export const fmtVal = (v, unit) => (v == null ? "—" : unit === "pct" ? `${v}%` : unit === "tzs" ? `TZS ${Number(v).toLocaleString("en-US")}` : String(v));

export const StatusBadge = ({ s, id }) => <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${T_BADGE[s]}`} data-testid={id}>{T_LABEL[s]}</span>;

export function PeriodPicker({ type, setType, pkey, setKey, prefix }) {
  const input = type === "month" ? <input type="month" value={pkey} onChange={(e) => setKey(e.target.value)} className="rounded-md border bg-background px-2 py-1.5 text-sm" data-testid={`${prefix}-period-key`} />
    : <input value={pkey} onChange={(e) => setKey(e.target.value)} placeholder={type === "quarter" ? "2026-Q4" : "2026"} className="w-28 rounded-md border bg-background px-2 py-1.5 text-sm" data-testid={`${prefix}-period-key`} />;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <select value={type} onChange={(e) => setType(e.target.value)} className="rounded-md border bg-background px-2 py-1.5 text-sm" data-testid={`${prefix}-period-type`}>
        <option value="month">Monthly</option><option value="quarter">Quarterly</option><option value="year">Yearly</option>
      </select>{input}
    </div>
  );
}

export const validKey = (type, k) => (type === "month" ? /^\d{4}-\d{2}$/ : type === "quarter" ? /^\d{4}-Q[1-4]$/ : /^\d{4}$/).test(k);

export const defaultKey = (type) => {
  const d = new Date(Date.now() + 3 * 3600 * 1000);
  return type === "month" ? d.toISOString().slice(0, 7) : type === "quarter" ? `${d.getUTCFullYear()}-Q${Math.floor(d.getUTCMonth() / 3) + 1}` : String(d.getUTCFullYear());
};

export const downloadNote = (id, name) => api.get(`/targets/notes/${id}/file`, { responseType: "blob" }).then((r) => {
  const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = name; a.click();
});
